import { computed } from "vue";
import { useI18n } from "vue-i18n";

type IDay = {
    id: "sun" | "mon";
    name: string;
};

export default function useDays() {
    const { locale } = useI18n();

    const days = computed((): IDay[] => [
        {
            id: "sun",
            name: locale.value === "en" ? "Sunday" : "Neděle",
        },
        {
            id: "mon",
            name: locale.value === "en" ? "Monday" : "Pondělí",
        },
    ]);

    return { days };
}
